/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { FormattedMessage } from '@atlassian/jira-intl';

export const Skeleton = (): React.JSX.Element => {
	return (
		<FormattedMessage
			id="router-routes-sandbox-entries.loading-the-sandbox-page"
			defaultMessage="Loading the sandbox page..."
			description="Loading message shown in the skeleton while the sandbox page is being loaded."
		/>
	);
};
